var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"stroke-current w-full h-full",attrs:{"fill":"none"}},[_c('use',{attrs:{"href":'#' + _vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }